import type FilterOption from './filterOption';

export type SelectedLabelID = number | null;
export type SelectedUserID = number | null;
export type FileType = 'image' | 'doc';
export type LabelFilterJSON = { ids: SelectedLabelID[]; match_all: boolean };
export type UserAssignedFilterJSON = { ids: SelectedUserID[]; match_all: boolean };
export type RoundFilterJSON = number[];
export type FileTypeFilterJSON = FileType;
export type FilterJSON = Record<
	string,
	LabelFilterJSON | UserAssignedFilterJSON | RoundFilterJSON | FileTypeFilterJSON | string | number | boolean | null
>;

export type AssetFilterMandatoryParams = {
	searchText: string;
	filterOptions: FilterOption[];
	isFilterSidePanelOpen: boolean;
	collapsedFilters: string[];
};

export type SortDirection = 'asc' | 'desc';

export const isLabelFilterJSON = ( json: FilterJSON ): json is { label: LabelFilterJSON } => (
	typeof json === 'object' && json !== null && 'label' in json
);

export const isUserAssignedFilterJSON = ( json: FilterJSON ): json is { assigned_to: UserAssignedFilterJSON } => (
	typeof json === 'object' && json !== null && 'assigned_to' in json
);

export const isRoundFilterJSON = ( json: FilterJSON ): json is { round: RoundFilterJSON } => (
	typeof json === 'object' && json !== null && 'round' in json && Array.isArray( json.round )
);

export const isFileTypeFilterJSON = ( json: FilterJSON ): json is { type: FileType } => (
	typeof json === 'object' && json !== null && 'type' in json && ( json.type === 'image' || json.type === 'doc' )
);
